<template>
  <div class="prSubsc">
    <img :src="imgPath + 'subsc_copy_second_half.png'" class="prSubsc__copy" alt="占いTV 月額会員になれば">
    <a :href="sbscUrl">
      <img :src="imgPath + 'subsc_banner.png'" class="prSubsc__banner" alt="見放題で見る">
    </a>
  </div>
</template>

<script>
export default {
  name: "prSubsc",
  props: {
    imgPath: {
      type: String,
      default: '',
    },
    sbscUrl: {
      type: String,
      default: '/user/login',
    }
  }
}
</script>

<style scoped lang="scss">
.prSubsc {
  margin: 0 auto;
  padding: 0 24px;
  max-width: 450px;
  &__copy,
  &__banner {
    display: block;
    max-width: 100%;
    vertical-align: middle;
    margin: 0 auto;
  }
  &__copy {
    margin: 0 0 24px;
  }
  &__banner {
    box-shadow: 5px 5px 15px rgba(0, 0, 0, 0.15);
    border-radius: 6%;
    transition: 0.2s;
    &:hover {
      opacity: 0.8;
    }
  }
}
</style>



// WEBPACK FOOTER //
// ../../../../resources/assets/js/utvStore/components/YearLuck/y2022/prSubsc.vue